import { useRouter } from 'next/router';
import React, { useEffect, useRef, useState } from 'react';
import { getPage } from '../api/wagtail';
import { useGlobalContext } from '../components/GlobalContextProvider/GlobalContextProvider';
import removeQueryParameters from '../utils/removeQueryParameters';

function useDynamicContentFetch(props, setIsLoading) {
  const router = useRouter();

  const [pageData, setPageData] = useState(props);
  const { isLogged } = useGlobalContext();
  const didMount = useRef(false);

  useEffect(() => {
    async function fetchContent() {
      if (
        router.asPath.includes('/preview/') ||
        router.asPath.includes('/_preview/')
      ) {
        return;
      }
      if (!didMount.current && !isLogged) {
        didMount.current = true;
      } else {
        setIsLoading(true);
        const partsOfUrl = router.asPath.split('#');
        const res = await getPage(removeQueryParameters(partsOfUrl[0]));

        setPageData(res.json.componentProps);
        setIsLoading(false);
      }
    }

    fetchContent();
  }, [isLogged, router.asPath]);

  return pageData;
}

export default useDynamicContentFetch;
